module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [_c('div', {
    staticClass: "box-header title-boreder"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-link btn-lg",
    on: {
      "click": function($event) {
        return _vm.advancedSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v("  Avanzado")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "filterContainer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "id": "divAccountSelect"
    }
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "value": this.selectedAccount,
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "track-by": "name",
      "placeholder": this.selectedAccount.name,
      "allow-empty": false,
      "label": "name",
      "options": this.optionsAccount
    },
    on: {
      "input": _vm.onAccountSelect
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("\n                  No se encontraron resultados\n                ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "dtDateRange"
    }
  }, [_vm._v("Desde - Hasta")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitted && _vm.message !== ''),
      expression: "submitted && message !== ''"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(this.message))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.showAdvance) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo Pedido")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.typeOrder),
      expression: "typeOrder"
    }],
    staticClass: "form-control minimal",
    attrs: {
      "id": "ddlTypeOrder"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.typeOrder = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((this.optionTypeOrder), function(type) {
    return _c('option', {
      key: type.code,
      domProps: {
        "value": type.code
      }
    }, [_vm._v("\n                    " + _vm._s(type.text) + "\n                  ")])
  }), 0)]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.showAdvance) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documentStatus),
      expression: "documentStatus"
    }],
    staticClass: "form-control minimal",
    attrs: {
      "id": "ddlDocumentStatus"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.documentStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((this.optionDocumentStatus), function(type) {
    return _c('option', {
      key: type.code,
      domProps: {
        "value": type.code
      }
    }, [_vm._v("\n                    " + _vm._s(type.text) + "\n                  ")])
  }), 0)]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-top": "25px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success btnAction",
    on: {
      "click": function($event) {
        return _vm.search()
      }
    }
  }, [_vm._v("Buscar")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.showAdvance) ? _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "id": "divClientSelect"
    }
  }, [_c('label', [_vm._v("Cliente")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "value": this.selectedClient,
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "track-by": "code",
      "placeholder": this.selectedClient.text,
      "allow-empty": false,
      "label": "text",
      "options": this.optionsClient
    },
    on: {
      "input": _vm.onClientSelect
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("\n                  No se encontraron resultados\n                ")])])], 1)]) : _vm._e()])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [((this.tableAllData && this.tableAllData.length) || (this.tableClientData && this.tableClientData.length)) ? _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticClass: "icon-space",
    staticStyle: {
      "padding-bottom": "3px"
    },
    attrs: {
      "src": "/static/img/icons/result.png"
    }
  }), _vm._v("\n          PERíODO " + _vm._s(_vm._f("formatDate")(_vm.searchParams.StartDate, 'L')) + " A " + _vm._s(_vm._f("formatDate")(_vm.searchParams.EndDate, 'L')) + " \n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    attrs: {
      "id": "ordersClientTable"
    }
  }, [_c('Vuetable', {
    attrs: {
      "id": "ordersClientTable",
      "api-mode": false,
      "fields": _vm.tableClientFields,
      "data": _vm.tableClientData,
      "css": _vm.tableCSS.table,
      "noDataTemplate": "No se encontraron resultados"
    },
    scopedSlots: _vm._u([{
      key: "shippingDate",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Fecha"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatDate")(props.rowData.shippingDate, "DD/MM/YYYY")))])])]
      }
    }, {
      key: "orderCompleted",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Atendido"
          }
        }, [_c('div', {
          staticClass: "progressContainer"
        }, [_c('div', {
          staticClass: "porcentajeTotal",
          style: ('font-size: 14px ;margin:-3px 25px 0 -85px;color:#4E6982;')
        }, [_vm._v(_vm._s(_vm._f("currency")(props.rowData.totalShippedPorcentage)) + "%\n                    ")]), _vm._v(" "), _c('div', {
          staticClass: "progressBar",
          staticStyle: {
            "position": "absolute !important",
            "margin-left": "-35px",
            "margin-top": "1px"
          }
        }, [_c('div', {
          staticClass: "progress table-bar percentageA",
          style: ('background-color:#D9DEFB')
        }, [_c('div', {
          class: 'progress-bar progress-bar ',
          style: ('background-color:#536DFE;width:' + props.rowData.totalShippedPorcentage + '%'),
          attrs: {
            "role": "progressbar",
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "totalPorcentaje",
          style: ('margin:-16px 0px 0px 135px;color:#506A83')
        }, [_c('span', {
          staticStyle: {
            "font-size": "14px",
            "font-weight": "bold",
            "color": "#4E6982"
          }
        }, [_vm._v(_vm._s(_vm._f("formatAmount")(props.rowData.orderCompleted)))]), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "12px",
            "color": "#4E6982",
            "font-weight": "bold"
          }
        }, [_vm._v(_vm._s(props.rowData.minimumStockUnit))])])])])])]
      }
    }, {
      key: "orderProgress",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Proceso"
          }
        }, [_c('div', {
          staticClass: "progressContainer"
        }, [_c('div', {
          staticClass: "porcentajeTotal",
          style: ('font-size: 14px ;margin: -3px 25px 0 -70px; color:#4E6982')
        }, [_vm._v(_vm._s(_vm._f("currency")(props.rowData.totalProgressPorcentage)) + "%\n                    ")]), _vm._v(" "), _c('div', {
          staticClass: "progressBar",
          staticStyle: {
            "position": "absolute !important",
            "margin-left": "-20px",
            "margin-top": "1px"
          }
        }, [_c('div', {
          staticClass: "progress table-bar percentageA",
          style: ('background-color:#B6F5BB')
        }, [_c('div', {
          class: 'progress-bar progress-bar',
          style: ('background-color:#63CB68;width:' + props.rowData.totalProgressPorcentage + '%'),
          attrs: {
            "role": "progressbar",
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "totalPorcentaje",
          style: ('margin:-16px 0px 0px 135px;color:#4E6982')
        }, [_c('span', {
          staticStyle: {
            "font-size": "14px",
            "font-weight": "bold",
            "color": "#4E6982"
          }
        }, [_vm._v(_vm._s(_vm._f("formatAmount")(props.rowData.orderProgress)))]), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "12px",
            "color": "#4E6982",
            "font-weight": "bold"
          }
        }, [_vm._v(_vm._s(props.rowData.minimumStockUnit))])])])])])]
      }
    }, {
      key: "orderPending",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Pendientes"
          }
        }, [_c('div', {
          staticClass: "progressContainer"
        }, [_c('div', {
          staticClass: "porcentajeTotal",
          style: ('font-size: 14px ;margin:-3px 25px 0 -40px; color:#4E6982')
        }, [_vm._v(_vm._s(_vm._f("currency")(props.rowData.totalPendingPorcentage)) + "%\n                    ")]), _vm._v(" "), _c('div', {
          staticClass: "progressBar",
          staticStyle: {
            "position": "absolute !important",
            "margin-left": "12px",
            "margin-top": "4px"
          }
        }, [_c('div', {
          staticClass: "progress table-bar percentageA",
          style: ('background-color:#C6E9F8')
        }, [_c('div', {
          class: 'progress-bar progress-bar',
          style: ('background-color:#4FC3F7;width:' + props.rowData.totalPendingPorcentage + '%'),
          attrs: {
            "role": "progressbar",
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "totalPorcentaje",
          style: ('margin:-15px  0 0 140px;color:#4E6982')
        }, [_c('span', {
          staticStyle: {
            "font-size": "14px",
            "font-weight": "bold",
            "color": "#4E6982"
          }
        }, [_vm._v(_vm._s(_vm._f("formatAmount")(props.rowData.orderPending)))]), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "12px",
            "color": "#4E6982",
            "font-weight": "bold"
          }
        }, [_vm._v(_vm._s(props.rowData.minimumStockUnit))])])])])])]
      }
    }, {
      key: "orderTotal",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Total"
          }
        }, [_c('span', {
          staticStyle: {
            "font-size": "16px",
            "font-weight": "bold",
            "position": "relative"
          }
        }, [_vm._v(_vm._s(_vm._f("formatAmount")(props.rowData.orderTotal)))]), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "14px",
            "color": "#4E6982",
            "font-weight": "bold"
          }
        }, [_vm._v(_vm._s(props.rowData.minimumStockUnit))])])]
      }
    }, {
      key: "orderBtnDetail",
      fn: function(props) {
        return [_c('div', [_c('div', {
          staticClass: "text-center botonVerDetalle",
          staticStyle: {
            "margin-top": "-5px"
          }
        }, [(_vm.window.width > 1200) ? _c('router-link', {
          staticClass: "btn table-btn",
          attrs: {
            "to": {
              name: 'OrdersProgressDetail',
              params: {
                filterOrdereDate: props.rowData,
                showAdvanceMain: _vm.showAdvance
              }
            },
            "tag": "button"
          }
        }, [_c('span', {
          staticClass: "table-btn-icon"
        })]) : _vm._e(), _vm._v(" "), (_vm.window.width < 1200) ? _c('router-link', {
          staticClass: "btn table-btn verDetalle",
          attrs: {
            "to": {
              name: 'OrdersProgressDetail',
              params: {
                filterOrdereDate: props.rowData,
                showAdvanceMain: _vm.showAdvance
              }
            },
            "tag": "button"
          }
        }, [_c('span', {
          staticStyle: {
            "color": "#364A5D",
            "font-size": "14px",
            "font-weight": "bold"
          }
        }, [_vm._v("Ver detalles")])]) : _vm._e()], 1)])]
      }
    }])
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('h3', {
    staticClass: "box-title title"
  }, [_vm._v("Avance de pedidos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticClass: "icon-space",
    staticStyle: {
      "padding-bottom": "7px"
    },
    attrs: {
      "src": "/static/img/icons/search.png"
    }
  }), _vm._v("Buscar Resultados\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-calendar"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "dtDateRange",
      "mode": "text"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1dbaeb6c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/OrdersProgress.vue
// module id = 504
// module chunks = 1